import { useNavigate } from 'react-router-dom';
import { openExternalLink } from '../../../utils/openExternalLink';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { DISTRIBUTION_URL } from '../constants';

export const CpaDeclinedDialog = () => {
    const navigate = useNavigate();
    const t = useTranslation();

    const handleClose = () => {
        navigate(-1);
    };

    const handleLearnMore = () => {
        openExternalLink(DISTRIBUTION_URL);
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Регистрация отклонена')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={4} width="100%">
            <Box>
                <Typography variant="body">
                    {t('Проверьте статус вашей заявки или обратитесь в поддержку')}
                </Typography>
            </Box>

            <Box width="100%">
                <Button
                    variant="filled"
                    size="l"
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                    onClick={handleLearnMore}
                >
                    {t('Перейти в кабинет')}
                </Button>
            </Box>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
